import React from "react";
import { SterilizationComponent, BackgroundImage,TeethLogo } from "../../Components";

const Sterilization = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_sterilization} text={selectedLanguage?.txt_latest_technology} mainClass='sterilization-banner' />
            <TeethLogo heading={selectedLanguage?.txt_sterilization} text1={selectedLanguage?.txt_protecting_is_a_priority_to_us}/>
            <SterilizationComponent {...props}/>
        </div>
    )
}

export default Sterilization